
export default { name: "tess-logo" };
